import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

const Mission = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center max-w-5xl mx-auto">
          <p className="text-2xl md:text-4xl font-light leading-relaxed">
            {t.mission}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Mission;
